import { PlusIcon } from '@heroicons/react/16/solid'

const tiers = [
  {
    name: 'Panamá',
    img: '/Trips/PANAMA.jfif',
    description: 'Entre rascacielos y gigantes del mar, Panamá sorprende.',
    price: 'Q4,936',
    highlights: [
      { description: 'Boletos aéreos ida y vuelta' },
      { description: 'Maleta de mano de 22 libras' },
      { description: 'Traslado aeropuerto — hotel — aeropuerto' },
      { description: '3 noches de alojamiento', disabled: true },
      { description: 'Cortesía de bienvenida', disabled: true },
      { description: 'Precio sujeto a disponibilidad', disabled: true },
    ],
  },
  {
    name: 'Petén',
    img: '/Trips/PETEN.jpg',
    description: 'Entre la selva y las ruinas, Petén te roba el corazón.',
    price: 'Q2,752',
    featured: true,
    highlights: [
      { description: 'Precio al contado desde Q2,752' },
      { description: 'Boletos aéreos ida y vuelta' },
      { description: 'Traslado aeropuerto — hotel — aeropuerto' },
      { description: '3 noches de alojamiento' },
      { description: 'Desayunos diarios', disabled: true },
      { description: 'Precio sujeto a disponibilidad', disabled: true },
    ],
  },
  {
    name: 'Cartagena',
    img: '/Trips/COLOMBIA.jpg',
    description: 'Historia, playa y magia caribeña en un solo destino.',
    price: 'Q2,995',
    highlights: [
      { description: 'Precio al contado desde Q2,995' },
      { description: 'Boletos aéreos ida y vuelta' },
      { description: 'Traslado aeropuerto — hotel — aeropuerto' },
      { description: '3 noches de alojamiento' },
      { description: 'Desayunos diarios' },
      { description: 'Precio sujeto a disponibilidad' },
    ],
  },
]

export default function PriceTrips() {
  return (
    <div className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">

        <div className="max-w-2xl mb-14">
          <p className="text-sm font-semibold uppercase tracking-widest mb-3" style={{ color: '#F5A020' }}>
            Paquetes de viaje
          </p>
          <h2 className="text-5xl font-extrabold tracking-tight text-gray-900 sm:text-6xl">
            Elige el mejor viaje
          </h2>
          <p className="mt-4 text-base text-gray-500">
            Vuelo, hotel y traslados incluidos. Todo listo para que solo te preocupes de disfrutar.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {tiers.map((tier) => (
            <div
              key={tier.name}
              className={`relative flex flex-col rounded-2xl overflow-hidden border bg-white transition hover:shadow-lg duration-300 ${
                tier.featured ? 'border-[#F5A020] shadow-md' : 'border-gray-100 shadow-sm'
              }`}
            >
              {tier.featured && (
                <div
                  className="absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-bold text-white z-10"
                  style={{ background: '#F5A020' }}
                >
                  Más popular
                </div>
              )}

              <div className="relative h-48 overflow-hidden">
                <img
                  src={tier.img}
                  alt={tier.name}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                />
                <div
                  className="absolute inset-0"
                  style={{ background: 'linear-gradient(to top, rgba(46,56,164,0.55) 0%, transparent 55%)' }}
                />
                <h3 className="absolute bottom-4 left-5 text-xl font-extrabold text-white tracking-wide">
                  {tier.name}
                </h3>
              </div>

              <div className="flex flex-col flex-1 p-7">
                <p className="text-sm text-gray-400 mb-5">{tier.description}</p>

                <div className="flex items-end gap-2 mb-6">
                  <span className="text-4xl font-extrabold text-gray-900">{tier.price}</span>
                  <span className="text-sm text-gray-400 mb-1">al contado</span>
                </div>

                <a
                  href={`https://wa.me/50239990332?text=${encodeURIComponent(`Hola, estoy interesado en el viaje a ${tier.name}`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full text-center py-3 rounded-xl font-bold text-white text-sm transition hover:opacity-90"
                  style={{ background: tier.featured ? '#F5A020' : '#2E38A4' }}
                >
                  Reservar ahora
                </a>

                <div className="mt-6 pt-6 border-t border-gray-100">
                  <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-3">Incluye</p>
                  <ul className="space-y-2.5">
                    {tier.highlights.map((h) => (
                      <li
                        key={h.description}
                        className={`flex items-start gap-3 text-sm ${h.disabled ? 'text-gray-300' : 'text-gray-600'}`}
                      >
                        <PlusIcon
                          aria-hidden="true"
                          className={`mt-0.5 h-4 w-4 flex-shrink-0 ${h.disabled ? 'fill-gray-200' : 'fill-[#F5A020]'}`}
                        />
                        {h.description}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <p className="text-sm text-gray-400 mb-5">¿No encontraste lo que buscas? Tenemos muchos más destinos.</p>
          <a
            href={`https://wa.me/50239990332?text=${encodeURIComponent('Quiero información sobre más destinos')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 rounded-xl font-bold text-white text-base shadow transition hover:opacity-90"
            style={{ background: '#2E38A4' }}
          >
            Explorar más destinos
          </a>
        </div>
      </div>
    </div>
  )
}
